import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { Appointment } from './appointment.interface';
import { AppointmentService } from './appointment.service';

const service = new AppointmentService();

export interface AppointmentState {}

const AppointmentStore: Module<AppointmentState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async createAppointment(context, appointment: Appointment) {
         const response = await service.postAppointment(appointment);
         return response.data;
      },
   },
};

export default AppointmentStore;
